<template>
  <div
    v-if="isLoad"
  >
    <template v-if="!isGroupByUser">
      <div 
        v-if="orderServices.length > 0"
        class="mb-2"
        v-for="(order_service, i) in orderServices"
      >
        <div 
          @click="openOrderSidebar(order_service.order_id, '', {tab: '23'})"
          class="mt-3 mb-2 ml-2 text-muted cursor-pointer"
        >Поставка #{{ order_service.order_id }} / <span v-html="getCompanyFromOrderService(order_service)"></span></div>

        <GraphByDays
          v-if="greatPeriodInDays && isPeriodLoad"
          :order-status-history="order_service.order_status_history"
          :activities="order_service.activities"
        />

        <GraphByHours
          v-if="!greatPeriodInDays && isPeriodLoad"
          :order-status-history="order_service.order_status_history"
          :activities="order_service.activities"
        />
      </div>
      <div v-if="orderServices.length == 0">
        <b-jumbotron class="mb-0">
          <template #header>
              <h3 class="display-5">Результаты отсутствуют</h3>
          </template>
      
          <template #lead>
            Активности по поставкам не найдены. Попробуйте изменить критерии отбора по сотрудникам.
          </template>

        </b-jumbotron>            
      </div>
    </template>
    <template v-else>
      <div 
        class="mb-2"
        v-for="(user, i) in orderServices"
      >
        <div class="mt-3 mb-2 ml-2 text-muted">{{ user.user.user_name }}</div>
        <GroupedGraphByDays
          :activities="user.activities"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { openOrderSidebar } from '@/mixins/openOrderSidebar';
import GraphByDays from '@/components/orders/orderServiceTemplate/v2/activeHistory/GraphByDays';
import GraphByHours from '@/components/orders/orderServiceTemplate/v2/activeHistory/GraphByHours';
import GroupedGraphByDays from '@/components/orders/orderServiceTemplate/v2/activeHistory/GroupedGraphByDays';  
import { API_ORDERS_SERVICE_ACTIVITY_HISTORY } from '@/constants';
import { constantsAllReferenceProperties, constantsAllLogisticsProperties } from '@/mixins';

export default {
  props: {
    serviceIds: {
      type: Number|String,
      default: '',
    },
    userIds: {
      type: Number|String,
      default: '',
    },
    isGroupByUser: {
      type: Boolean,
      default: false,
    },
    isNotClosedOrders: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    openOrderSidebar,
    constantsAllReferenceProperties,
    constantsAllLogisticsProperties
  ],  
  components: {
    GraphByDays,
    GraphByHours,
    GroupedGraphByDays
  },
  data() {
    return {
      greatPeriod: [],
      greatPeriodInDays: true,
      orderServices: [],
      isLoad: false,
      isPeriodLoad: false,
      referencePropertiesList: {}, // Странно, из миксина приходит пустой
    }
  },
  watch: {
    userIds: {
        handler(newVal, oldVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                this.getHistory();
            }
        },
        deep: true
    },
    serviceIds: {
        handler(newVal, oldVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                this.getHistory();
            }
        },
        deep: true
    },
    isGroupByUser: {
        handler(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getHistory();
            }
        }
    },
    isNotClosedOrders: {
        handler(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getHistory();
            }
        }
    }
    },
  mounted() {
    this.getHistory();
  },
  methods: {
    getHistory() {
      this.isLoad = false;
      this.isPeriodLoad = false;
      if (this.serviceIds || this.userIds) {
        const baseUrl = `${API_ORDERS_SERVICE_ACTIVITY_HISTORY}`;
          let queryParams = [];
          if (this.userIds) {
              queryParams.push(`user_ids=${encodeURIComponent(this.userIds)}`);
          }
          if (this.serviceIds) {
              queryParams.push(`order_service_ids=${encodeURIComponent(this.serviceIds)}`);
          }
          if (this.isGroupByUser) {
              queryParams.push(`isGroupByUser=${encodeURIComponent(this.isGroupByUser)}`);
          }
          if (this.isNotClosedOrders) {
              queryParams.push(`isNotClosedOrders=${encodeURIComponent(this.isNotClosedOrders)}`);
          }

          const urlWithParams = queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;

          axios.get(urlWithParams)        
          .then(data => {
            this.orderServices = data.data;
            this.isLoad = true;

            if (!this.isGroupByUser) {
              this.orderServices.forEach((order_service, i) => {
                for(let index in this.orderServices[i].activities) {
                  this.orderServices[i].activities[index].forEach((activity, j) => {
                    this.orderServices[i].activities[index][j].property_value = this.getFieldValue(activity);
                    this.orderServices[i].activities[index][j].property_name = this.getFieldName(activity.property_name);
                  });
                }              
              });
            } else {
              this.orderServices.forEach((user_order_service, u_idx) => {
                for(let o_idx in this.orderServices[u_idx].activities) {
                  for(let a_idx in this.orderServices[u_idx].activities[o_idx]) {
                    this.orderServices[u_idx].activities[o_idx][a_idx].forEach((activity, j) => {
                      this.orderServices[u_idx].activities[o_idx][a_idx][j].property_value = this.getFieldValue(activity);
                      this.orderServices[u_idx].activities[o_idx][a_idx][j].property_name = this.getFieldName(activity.property_name);
                    });
                  }
                }              
              });
            }
          })
          .then(() => {
            if (!this.isGroupByUser) {
              this.calcPeriodInDaysOrHours();
            }
          })
      }
    },
    calcPeriodInDaysOrHours() {
      this.orderServices.forEach((order_service, i) => {
        for(let index in this.orderServices[i].activities) {
          this.orderServices[i].activities[index].forEach((activity, j) => {
            this.greatPeriod.push(activity.created_at);
          });

          if (Object.keys(this.orderServices[i].activities[index]).every((a_val, a_i, a_arr) => this.$moment(a_val.created_at).format('DD.MM.YYYY') === this.$moment(a_arr[0].created_at).format('DD.MM.YYYY'))) {
            this.orderServices[i].periodInDays = false;
          } else {
            this.orderServices[i].periodInDays = true;
          }
        }              
      });
      
      if (this.greatPeriod.every((val, i, arr) => this.$moment(val).format('DD.MM.YYYY') === this.$moment(arr[0]).format('DD.MM.YYYY'))) {
        this.greatPeriodInDays = false
      } else {
        this.greatPeriodInDays = true
      }

      this.isPeriodLoad = true;
    },
    findRealName(property_name) {
      if (this.logisticsDataNames[property_name]) {
        return this.logisticsDataNames[property_name];
      }
      return property_name;
    },
    getFieldName(property_name) {
      if (this.findRealName(property_name) != property_name) {
        return this.findRealName(property_name);
      }

      let processedParts = property_name.split('.');
      if (processedParts.length > 1) {
        processedParts = processedParts.map(part => {
          let partTmp = parseInt(part);
          if (!isNaN(part) && partTmp !== NaN) {
            return partTmp + 1;
          }

          return this.findRealName(part);
        });

        let processedPropertyName = processedParts.join('.');

        return processedPropertyName;
      }

      if (property_name === 'reference_property_status_id') {
        return "Статус";
      } else if (property_name === 'reference_property_type_id') {
        return "Тип поставки";
      } 
      
      return this.findRealName(property_name);
    },
    getFieldValue(act) {
      if (act.property_name.includes('_id')) {
        if (this.$store.getters.REFERENCE_PROPERTIES[act.property_value]) {
          return this.$store.getters.REFERENCE_PROPERTIES[act.property_value].text;
        }
      } 

      return this.formatDateOrDatetime(act.property_value);
    },
    getCompanyFromOrderService(order_service) {
      let company = 'Компания не указана';

      if (order_service.company) {
        company = `<span title="${order_service.company.inn}">${order_service.company.name}</span>`;
      }

      return company;
    },    
    formatDateOrDatetime(input) {
      return input;

      // Некоторые числа, типа веса все равно определяются как даты, пока замокал
      const date = new Date(input);

      if (!isNaN(date.getTime())) {
        // Check if it includes a time part (not just a date)
        if (input.includes('T') || input.includes(':')) {
          // Format as 'DD.MM.YYYY HH:mm'
          return date.toLocaleDateString('ru-Ru', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }).replace(',', '');
        } else {
          // Format as 'DD.MM.YYYY'
          return date.toLocaleDateString('ru-Ru', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        }
      } else {
        return input;
      }
    }
  },
}
</script>